$('#gallery ul').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  prevArrow: false,
  nextArrow: false,
  responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
});

$('#footer_gallery ul').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  cssEase: 'linear',
  prevArrow: '<a href="#" class="swiper-button-prev js-swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></a>',
  nextArrow: '<a href="#" class="swiper-button-next js-swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></a>',
  responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
});

$('.swiper-wrapper_slick').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  prevArrow: '<a href="#" class="swiper-button-prev js-swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></a>',
  nextArrow: '<a href="#" class="swiper-button-next js-swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline></svg></a>',
  responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* CLAUDE-SLIDER-PAGINA-INTERA */
/* Le frecce degli slider prodotto avanzavano di UNA card alla volta
   (slidesPerGroup:1, default Swiper). Qui, a inizializzazione avvenuta,
   il gruppo diventa una pagina intera: con 6 card visibili si scorre di 6.
   Retry per qualche secondo perche' il tema inizializza Swiper in differita. */
(function () {
  'use strict';
  function applica() {
    var boxes = document.querySelectorAll('.section-featured-collection .swiper-container, .section-product-recommendations .swiper-container');
    var fatti = 0;
    boxes.forEach(function (el) {
      var sw = el.swiper;
      if (!sw) return;
      /* Completa il tuo look: 6 per riga come i landing slider (lo schema
         della sezione e' bloccato a 4 dal validatore dei template). */
      if (el.closest('.section-product-recommendations') &&
          window.matchMedia('(min-width: 768px)').matches &&
          sw.params.slidesPerView !== 6) {
        sw.params.slidesPerView = 6;
        sw.update();
      }
      var visibili = Math.max(1, Math.floor(sw.params.slidesPerView) || 1);
      if (sw.params.slidesPerGroup !== visibili) {
        sw.params.slidesPerGroup = visibili;
        sw.update();
      }
      fatti++;
    });
    return boxes.length > 0 && fatti === boxes.length;
  }
  var tentativi = 0;
  var timer = setInterval(function () {
    tentativi++;
    if (applica() || tentativi > 20) clearInterval(timer);
  }, 500);
  window.addEventListener('resize', function () { applica(); });
})();

/* CLAUDE-SLIDER-PRECARICA */
/* Il primo click sulla freccia era lento: le card della seconda pagina
   hanno immagini lazy (lazysizes) che partivano solo quando entravano
   in vista. Dopo l'init le sblocco tutte, cosi' lo scorrimento e' fluido. */
(function () {
  'use strict';
  function precarica() {
    var imgs = document.querySelectorAll('.section-featured-collection .swiper-container img.lazyload, .section-product-recommendations .swiper-container img.lazyload');
    if (!imgs.length) return true;
    imgs.forEach(function (img) {
      if (window.lazySizes && lazySizes.loader && lazySizes.loader.unveil) {
        lazySizes.loader.unveil(img);
      } else {
        var d = img.getAttribute('data-src'); if (d) img.src = d;
        var ds = img.getAttribute('data-srcset'); if (ds) img.srcset = ds;
        img.classList.remove('lazyload');
      }
    });
    return true;
  }
  var n = 0;
  var t = setInterval(function () { n++; if (precarica() && n > 6) clearInterval(t); }, 800);
})();

/* CLAUDE-FIT-PER-RAPPORTO */
/* Card slider: box tutti uguali ma foto con rapporti diversi
   (pochette 0.87, scarpe 0.80, abito steso ~1.0, modelli 0.67).
   Con contain le foto larghe restavano basse e sembravano card
   piu' piccole. Decisione per-immagine dal rapporto reale:
     - foto LARGHE (>0.72: still life, scarpe, borse) -> cover,
       riempiono il box e il taglio cade ai lati sul fondale vuoto
     - foto VERTICALI (modelli) -> contain, nessuna testa tagliata */
(function () {
  'use strict';
  var SOGLIA = 0.72;
  function applica() {
    var imgs = document.querySelectorAll('.section-product-recommendations .product-block .image img, .section-featured-collection .product-block .image img, .section-featured-collection .product-block .rimage__image');
    var pronte = 0;
    imgs.forEach(function (img) {
      if (!img.naturalWidth) return;
      pronte++;
      var r = img.naturalWidth / img.naturalHeight;
      img.style.setProperty('object-fit', r > SOGLIA ? 'cover' : 'contain', 'important');
      img.style.setProperty('object-position', 'center center', 'important');
    });
    return imgs.length > 0 && pronte === imgs.length;
  }
  var n = 0;
  var t = setInterval(function () { n++; if (applica() || n > 25) clearInterval(t); }, 400);
  document.addEventListener('lazyloaded', function (e) {
    var img = e.target;
    if (img && img.naturalWidth && img.closest('.section-featured-collection, .section-product-recommendations')) {
      var r = img.naturalWidth / img.naturalHeight;
      img.style.setProperty('object-fit', r > SOGLIA ? 'cover' : 'contain', 'important');
    }
  });
})();

/* CLAUDE-FILTRI-LVR */
/* Drawer "Tutti i filtri" + tendine: una sola aperta, chiusura su click fuori,
   stato che sopravvive al re-render AJAX della form. */
(function () {
  var drawerOpen = false;
  var lastOpen = null;

  function filterEl() {
    return document.querySelector('.theme-filter-container .cc-product-filter');
  }
  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }
  function applyState() {
    var f = filterEl();
    if (!f) return;
    f.classList.toggle('opp-drawer', drawerOpen);
    document.body.classList.toggle('opp-filters-drawer-open', drawerOpen);
  }

  document.addEventListener('click', function (e) {
    var f = filterEl();
    if (!f) return;
    if (e.target.closest('.opp-allfilters-btn')) { drawerOpen = true; applyState(); return; }
    if (e.target.closest('.opp-drawer-close')) { drawerOpen = false; applyState(); return; }
    if (drawerOpen && !e.target.closest('.cc-product-filter')) { drawerOpen = false; applyState(); return; }
    if (!drawerOpen && isDesktop() && !e.target.closest('.cc-product-filter')) {
      f.querySelectorAll('#FacetsForm > .cc-accordion details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawerOpen) { drawerOpen = false; applyState(); }
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.closest('.cc-product-filter')) return;
    var s = d.querySelector('summary');
    var t = s ? s.textContent.trim() : '';
    if (d.open) {
      lastOpen = t;
      if (!drawerOpen && isDesktop()) {
        d.closest('#FacetsForm').querySelectorAll(':scope > .cc-accordion details[open]').forEach(function (o) {
          if (o !== d) o.removeAttribute('open');
        });
      }
    } else if (lastOpen === t) {
      lastOpen = null;
    }
  }, true);

  var mo = new MutationObserver(function () {
    var f = filterEl();
    if (!f) return;
    if (drawerOpen && !f.classList.contains('opp-drawer')) applyState();
    if (lastOpen) {
      var dets = f.querySelectorAll('#FacetsForm details');
      for (var i = 0; i < dets.length; i++) {
        var s = dets[i].querySelector('summary');
        if (s && s.textContent.trim() === lastOpen) {
          if (!dets[i].open) dets[i].setAttribute('open', '');
          break;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* CLAUDE-FILTRI-LVR-DRAWER */
/* Click sul velo (che e' ::before del drawer, quindi target = il drawer
   stesso): chiude. I click sul contenuto colpiscono i figli, non l'elemento. */
document.addEventListener('click', function (e) {
  var t = e.target;
  if (t && t.classList && t.classList.contains('cc-product-filter') &&
      t.classList.contains('opp-drawer')) {
    t.classList.remove('opp-drawer');
    document.body.classList.remove('opp-filters-drawer-open');
  }
});

/* CLAUDE-FILTRI-LVR-CONTESTI */
/* Gli antenati del drawer creano stacking context (opacity/transform/z-index
   del sistema di animazioni) che lo intrappolano sotto header e velo. A drawer
   aperto li neutralizziamo INLINE con !important (batte qualsiasi foglio),
   alla chiusura ripristiniamo i valori originali. */
(function () {
  var patched = [];

  function unlock() {
    var f = document.querySelector('.cc-product-filter.opp-drawer');
    if (!f) return;
    var e = f.parentElement;
    while (e && e !== document.documentElement) {
      var c = getComputedStyle(e);
      var fixes = [];
      if (parseFloat(c.opacity) < 1) fixes.push(['opacity', '1']);
      if (c.transform !== 'none') fixes.push(['transform', 'none']);
      if (c.filter !== 'none') fixes.push(['filter', 'none']);
      if (c.position !== 'static' && c.zIndex !== 'auto') fixes.push(['z-index', 'auto']);
      if (fixes.length) fixes.push(['transition', 'none']);
      for (var i = 0; i < fixes.length; i++) {
        patched.push({ el: e, prop: fixes[i][0], old: e.style.getPropertyValue(fixes[i][0]), oldPrio: e.style.getPropertyPriority(fixes[i][0]) });
        e.style.setProperty(fixes[i][0], fixes[i][1], 'important');
      }
      e = e.parentElement;
    }
  }

  function relock() {
    for (var i = 0; i < patched.length; i++) {
      var p = patched[i];
      if (p.old) p.el.style.setProperty(p.prop, p.old, p.oldPrio);
      else p.el.style.removeProperty(p.prop);
    }
    patched = [];
  }

  new MutationObserver(function () {
    if (document.body.classList.contains('opp-filters-drawer-open')) {
      unlock();
    } else if (patched.length) {
      relock();
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* CLAUDE-FILTRI-LVR-ORDINE */
/* Ordine LVR dei gruppi (match sul titolo, regge se un gruppo manca su una
   collezione) + CATEGORIA aperta di default quando si apre il drawer. */
(function () {
  var ORDINE = [
    ['categoria', 1], ['designer', 2], ['brand', 2], ['taglia', 3],
    ['prezzo', 4], ['sconto', 5], ['colore', 6], ['materiale', 7],
    ['collezione', 8], ['ordina', 99]
  ];

  function riordina() {
    var accs = document.querySelectorAll('#FacetsForm > .cc-accordion');
    accs.forEach(function (acc) {
      var s = acc.querySelector('summary');
      if (!s) return;
      var t = s.textContent.trim().toLowerCase();
      var o = 50;
      for (var i = 0; i < ORDINE.length; i++) {
        if (t.indexOf(ORDINE[i][0]) === 0) { o = ORDINE[i][1]; break; }
      }
      acc.style.order = o;
    });
  }

  function apriCategoria() {
    var f = document.querySelector('.cc-product-filter.opp-drawer');
    if (!f) return;
    var aperti = f.querySelectorAll('#FacetsForm details[open]').length;
    if (aperti > 0) return;
    var dets = f.querySelectorAll('#FacetsForm > .cc-accordion details');
    for (var i = 0; i < dets.length; i++) {
      var s = dets[i].querySelector('summary');
      if (s && s.textContent.trim().toLowerCase().indexOf('categoria') === 0) {
        dets[i].setAttribute('open', '');
        break;
      }
    }
  }

  if (document.readyState !== 'loading') riordina();
  else document.addEventListener('DOMContentLoaded', riordina);

  new MutationObserver(function () {
    riordina();
    if (document.body.classList.contains('opp-filters-drawer-open')) apriCategoria();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* CLAUDE-FILTRI-LVR-TOGGLE */
/* Apertura/chiusura diretta dei gruppi filtro (desktop): bypassa l'accordion
   animato del tema, che con i pannelli a visibilita' forzata non riusciva
   piu' a chiudere. Il collasso nativo di <details> funziona sempre. */
document.addEventListener('click', function (e) {
  if (!window.matchMedia('(min-width: 768px)').matches) return;
  var sum = e.target.closest('.cc-product-filter summary');
  if (!sum) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var d = sum.closest('details');
  if (!d) return;
  if (d.hasAttribute('open')) d.removeAttribute('open');
  else d.setAttribute('open', '');
}, true);

/* CLAUDE-PDP-RECENSIONI */
/* Il click sul rating lo gestisce il popup nativo Loox
   (looxOpenFloatingWidget attivo nel blocco, come su pierpaolomarotta). */

/* CLAUDE-FILTRI-MOBILE */
/* Filtri -> overlay nativo del tema; Ordina -> dropdown che spunta i radio
   sort della form (l'AJAX del tema fa il resto). */
document.addEventListener('click', function (e) {
  var filtri = e.target.closest('.opp-mob-filtri');
  if (filtri) {
    var t = document.querySelector('[data-show-filter]');
    if (t) t.click();
    return;
  }
  var sortBtn = e.target.closest('.opp-mob-sort__btn');
  var sortBox = document.querySelector('.opp-mob-sort');
  if (sortBtn && sortBox) {
    sortBox.classList.toggle('is-open');
    return;
  }
  var opt = e.target.closest('.opp-mob-sort__opt');
  if (opt) {
    var val = opt.getAttribute('data-sort');
    var radio = document.querySelector('#FacetsForm input[name="sort_by"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', val);
      location.href = u.toString();
    }
    if (sortBox) sortBox.classList.remove('is-open');
    return;
  }
  if (sortBox && sortBox.classList.contains('is-open') && !e.target.closest('.opp-mob-sort')) {
    sortBox.classList.remove('is-open');
  }
});

/* CLAUDE-MOBILE-HEADER-VAR */
/* --opp-header-h = altezza reale dell'header fisso (annuncio incluso):
   la toolbar sticky mobile si attacca esattamente sotto. */
(function () {
  function aggiorna() {
    var sc = document.querySelector('div.site-control');
    if (!sc) return;
    var h = Math.round(sc.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--opp-header-h', h + 'px');
  }
  if (document.readyState !== 'loading') aggiorna();
  else document.addEventListener('DOMContentLoaded', aggiorna);
  window.addEventListener('resize', aggiorna);
  window.addEventListener('scroll', function () { requestAnimationFrame(aggiorna); }, { passive: true });
})();

/* CLAUDE-FILTRI-MOBILE-CHIUSURA */
/* Pannello filtri mobile: chiusura con la X o col tap sulla striscia destra. */
document.addEventListener('click', function (e) {
  var f = document.querySelector('.cc-product-filter.-in');
  if (!f) return;
  var toggle = document.querySelector('[data-show-filter]');
  if (!toggle) return;
  if (f.contains(e.target) && e.target.closest('.opp-drawer-close')) {
    toggle.click();
    return;
  }
  if (!f.contains(e.target) &&
      !e.target.closest('.opp-mob-filtri') &&
      !e.target.closest('[data-show-filter]')) {
    toggle.click();
  }
});

/* CLAUDE-MNAV-PASKAL */
/* Drawer mobile a schede: gestione tab DONNA/UOMO (con memoria),
   drill-in dei sottopannelli, reset alla riapertura, bottone WhatsApp
   costruito dal numero di telefono gia' configurato nel tema. */
(function () {
  var menu = document.getElementById('page-menu');
  if (!menu || !menu.querySelector('[data-opp-mnav]')) return;
  var scrollBox = menu.querySelector('.nav-container');
  var scrollPrima = 0;

  function attiva(genere, salva) {
    var trovato = false;
    menu.querySelectorAll('[data-opp-tab]').forEach(function (t) {
      var on = t.getAttribute('data-opp-tab') === genere;
      t.classList.toggle('is-active', on);
      if (on) trovato = true;
    });
    if (!trovato) return attiva('donna', false);
    menu.querySelectorAll('[data-opp-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-opp-panel') === genere);
    });
    if (salva) { try { localStorage.setItem('opp-genere', genere); } catch (e) {} }
  }

  function chiudiSub() {
    menu.classList.remove('opp-sub-open');
    menu.querySelectorAll('.opp-mnav__sub.is-open').forEach(function (s) {
      s.classList.remove('is-open');
    });
    if (scrollBox) scrollBox.scrollTop = scrollPrima;
  }

  function genereIniziale() {
    var p = (location.pathname + '').toLowerCase();
    if (/uomo/.test(p)) return 'uomo';
    if (/donna/.test(p)) return 'donna';
    try { return localStorage.getItem('opp-genere') || 'donna'; } catch (e) { return 'donna'; }
  }
  attiva(genereIniziale(), false);

  menu.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-opp-tab]');
    if (tab) { attiva(tab.getAttribute('data-opp-tab'), true); return; }

    var voce = e.target.closest('[data-opp-sub]');
    if (voce) {
      var id = voce.getAttribute('data-opp-sub');
      var sub = menu.querySelector('[data-opp-subpanel="' + id + '"]');
      if (sub) {
        scrollPrima = scrollBox ? scrollBox.scrollTop : 0;
        menu.classList.add('opp-sub-open');
        sub.classList.add('is-open');
        if (scrollBox) scrollBox.scrollTop = 0;
      }
      return;
    }

    if (e.target.closest('[data-opp-back]')) { chiudiSub(); return; }
    if (e.target.closest('[data-modal-close]')) { setTimeout(chiudiSub, 350); }
  });

  /* riaprendo il drawer si riparte dalla lista principale */
  document.addEventListener('click', function (e) {
    if (e.target.closest('a[data-modal-toggle]')) setTimeout(chiudiSub, 350);
  });

  /* bottone WhatsApp accanto alla riga telefono */
  var call = menu.querySelector('.nav-footer-links .call a[href^="tel:"]');
  if (call && !menu.querySelector('.opp-wa-btn')) {
    var cifre = (call.getAttribute('href') || '').replace(/\D/g, '');
    if (cifre) {
      if (cifre.slice(0, 2) !== '39') cifre = '39' + cifre.replace(/^0+/, '');
      var wa = document.createElement('a');
      wa.className = 'opp-wa-btn';
      wa.href = 'https://wa.me/' + cifre;
      wa.target = '_blank';
      wa.rel = 'noopener';
      wa.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 2.7C8.7 2.7 2.8 8.6 2.8 15.9c0 2.6.8 5.1 2.2 7.2L2.7 29.3l6.4-2.2c2 1.2 4.4 1.9 6.9 1.9 7.3 0 13.2-5.9 13.2-13.2S23.3 2.7 16 2.7zm0 24c-2.2 0-4.3-.6-6.1-1.8l-.4-.3-3.8 1.3 1.3-3.7-.3-.4c-1.3-1.9-2-4.1-2-6.4C4.7 9.7 9.8 4.7 16 4.7s11.3 5.1 11.3 11.3S22.2 26.7 16 26.7zm6.2-8.5c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1 1.3-.2.2-.4.3-.7.1-.3-.2-1.4-.5-2.7-1.7-1-.9-1.7-2-1.9-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.6.1-.2 0-.4 0-.6-.1-.2-.8-1.9-1-2.6-.3-.6-.6-.5-.8-.5h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.4 1.4 3.6c.2.2 2.4 3.7 5.9 5.2.8.4 1.5.6 2 .7.8.3 1.6.2 2.2.1.7-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.1-.3-.2-.6-.4z"/></svg>';
      call.parentElement.appendChild(wa);
    }
  }
})();

/* CLAUDE-MNAV-TEL */
/* La riga "Domande?" del drawer mostra il numero (dal tel: gia' configurato),
   non la label testuale del setting. */
(function () {
  var a = document.querySelector('#page-menu .call a[href^="tel:"]');
  if (!a) return;
  var d = (a.getAttribute('href') || '').replace(/\D/g, '');
  if (!d) return;
  var loc = d.slice(0, 2) === '39' ? d.slice(2) : d;
  var fmt = '+39 ' + (loc.length > 6 ? loc.slice(0, 4) + ' ' + loc.slice(4) : loc);
  var testo = [];
  a.childNodes.forEach(function (n) {
    if (n.nodeType === 3 && n.textContent.trim()) testo.push(n);
  });
  if (testo.length) {
    testo.forEach(function (n, i) { n.textContent = i === 0 ? ' ' + fmt : ''; });
  } else {
    a.appendChild(document.createTextNode(' ' + fmt));
  }
})();

/* CLAUDE-FILTRI-MOBILE-LVR2 */
/* Pannello filtri mobile: toggle diretto dei gruppi (il contenuto a
   visibilita' forzata rompe l'animazione del tema, come sul desktop) e
   CATEGORIA aperta di default quando il pannello si apre. */
(function () {
  function mobile() { return window.matchMedia('(max-width: 767px)').matches; }

  document.addEventListener('click', function (e) {
    if (!mobile()) return;
    var sum = e.target.closest('.cc-product-filter summary');
    if (!sum) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var d = sum.closest('details');
    if (!d) return;
    if (d.hasAttribute('open')) d.removeAttribute('open');
    else d.setAttribute('open', '');
  }, true);

  function agganciaPannello() {
    var f = document.querySelector('.theme-filter-container .cc-product-filter');
    if (!f || f.dataset.oppMobLvr === '1') return;
    f.dataset.oppMobLvr = '1';
    function apri() {
      if (!mobile() || !f.classList.contains('-in')) return;
      if (f.querySelectorAll('#FacetsForm details[open]').length > 0) return;
      var dets = f.querySelectorAll('#FacetsForm details');
      for (var i = 0; i < dets.length; i++) {
        var s = dets[i].querySelector('summary');
        if (s && s.textContent.trim().toLowerCase().indexOf('categoria') === 0) {
          dets[i].setAttribute('open', '');
          break;
        }
      }
    }
    new MutationObserver(apri).observe(f, { attributes: true, attributeFilter: ['class'] });
    apri();
  }
  if (document.readyState !== 'loading') agganciaPannello();
  else document.addEventListener('DOMContentLoaded', agganciaPannello);
  /* il re-render AJAX ricrea il contenitore */
  new MutationObserver(agganciaPannello).observe(document.body, { childList: true, subtree: true });
})();

/* CLAUDE-SLIDER-MOBILE-LVR */
/* Sotto i 768px gli slider prodotti mostrano 2 card per vista con gap
   2px, come LVR. Si patchano i params dello swiper E i suoi breakpoints
   piccoli (altrimenti vincono loro dopo update). */
(function () {
  function mobile() { return window.matchMedia('(max-width: 767px)').matches; }

  function patcha() {
    if (!mobile()) return;
    var conts = document.querySelectorAll(
      '.product-list.swiper-container, .section-featured-collection .swiper-container, .section-product-recommendations .swiper-container');
    conts.forEach(function (el) {
      var sw = el.swiper;
      if (!sw || !sw.params) return;
      sw.params.slidesPerView = 2;
      sw.params.spaceBetween = 2;
      var bps = sw.params.breakpoints;
      if (bps) {
        Object.keys(bps).forEach(function (k) {
          var w = parseInt(k, 10);
          if (!isNaN(w) && w < 768 && bps[k]) {
            bps[k].slidesPerView = 2;
            bps[k].spaceBetween = 2;
          }
        });
      }
      try { sw.update(); } catch (e) {}
    });
  }

  /* gli swiper nascono dopo il load: qualche tentativo scaglionato */
  var tentativi = 0;
  var t = setInterval(function () {
    patcha();
    if (++tentativi >= 30) clearInterval(t);
  }, 350);
  window.addEventListener('resize', patcha);
  /* gli swiper fuori viewport nascono allo scroll: ci si riaggancia */
  window.addEventListener('scroll', patcha, { passive: true });
})();

/* CLAUDE-GALLERY-MOBILE-LVR */
/* Gallery PDP mobile: (1) le frecce del tema non hanno la navigation
   agganciata -> click delegato su slidePrev/Next (solo quando la nativa
   manca); (2) barra di avanzamento stile LVR guidata su slideChange. */
(function () {
  function mobile() { return window.matchMedia('(max-width: 767px)').matches; }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.swiper-button-prev, .swiper-button-next');
    if (!btn) return;
    var cont = btn.closest('.swiper-container');
    if (!cont || !cont.swiper) return;
    var sw = cont.swiper;
    if (sw.navigation && sw.navigation.prevEl) return; /* nativa attiva */
    e.preventDefault();
    if (btn.classList.contains('swiper-button-prev')) sw.slidePrev();
    else sw.slideNext();
  }, true);

  function aggiornaBarra(sw) {
    if (!sw.el) return;
    var bar = sw.el.querySelector('.swiper-scrollbar');
    if (!bar) {
      /* la gallery del tema non ha l'elemento: lo creiamo noi */
      bar = document.createElement('div');
      bar.className = 'swiper-scrollbar';
      sw.el.appendChild(bar);
    }
    var drag = bar.querySelector('.swiper-scrollbar-drag');
    if (!drag) {
      drag = document.createElement('div');
      drag.className = 'swiper-scrollbar-drag';
      bar.appendChild(drag);
    }
    var n = sw.slides ? sw.slides.length : 0;
    if (n < 2) { bar.style.display = 'none'; return; }
    var i = typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex;
    drag.style.width = (100 / n) + '%';
    drag.style.transform = 'translateX(' + (i * 100) + '%)';
    drag.style.transition = 'transform .25s ease';
  }

  function aggancia() {
    if (!mobile()) return;
    document.querySelectorAll('.theme-gallery .swiper-container').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || el.dataset.oppBarra === '1') return;
      el.dataset.oppBarra = '1';
      aggiornaBarra(sw);
      sw.on('slideChange', function () { aggiornaBarra(sw); });
      sw.on('resize', function () { aggiornaBarra(sw); });
    });
  }
  var tent = 0;
  var t = setInterval(function () { aggancia(); if (++tent >= 30) clearInterval(t); }, 350);
  window.addEventListener('scroll', aggancia, { passive: true });
})();

/* CLAUDE-PDP-WISHLIST-ROW */
/* Sposta il div wishlist dentro la riga del carrello (come la
   pkb-atc-row di Paskal); observer per i re-render della form. */
(function () {
  function sposta() {
    var act = document.querySelector('.product-detail__form__action');
    var wish = document.querySelector('form.product-purchase-form .pro_wish_list');
    if (!act || !wish || act.contains(wish)) return;
    act.appendChild(wish);
  }
  if (document.readyState !== 'loading') sposta();
  else document.addEventListener('DOMContentLoaded', sposta);
  new MutationObserver(sposta).observe(document.body, { childList: true, subtree: true });
})();
